import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { GrupoClassificacaoClassificavelFormModule } from '../../../grupo-classificacao/classificavel/form';
import { ClienteClassificacaoFormComponent } from './form';

@NgModule({
    imports: [
        SharedModule,
        GrupoClassificacaoClassificavelFormModule
    ],
    declarations: [
        ClienteClassificacaoFormComponent
    ],
    exports: [
        ClienteClassificacaoFormComponent
    ]
})
export class ClienteClassificacaoModule { }
